<template>
  <div
    v-if="verifyIsOrderRepeated() !== ''"
    class="alert bg-yellow text-dark p-2 mx-3"
  >
    <strong>Atenção:</strong> As seguintes ordens estão duplicadas:
    {{ verifyIsOrderRepeated() }}
  </div>
  <table class="table table-striped table-sm table-bordered" :id="dataTable.id">
    <thead>
      <tr>
        <th>Ordem</th>
        <th>Tipo de Pergunta</th>
        <th>Pergunta</th>
        <th>Informação Complementar</th>
        <th class="text-center">Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="fs in surveyForms" :key="fs.id">
        <td>{{ fs.order }}</td>
        <td>
          {{ fs.componentName }} <small><br />{{ fs.componentVue }}</small>
        </td>
        <td>{{ fs.field1 }}</td>
        <td>{{ fs.field2 }}</td>
        <td class="text-center">
          <button
            type="button"
            class="btn btn-outline-danger btn-icon"
            title="Excluir"
            @click="$emit('deleteSurveyForm', fs.id)"
          >
            <i class="ph ph-trash" />
          </button>
          <button
            type="button"
            class="btn btn-outline-warning btn-icon ms-2"
            title="Editar"
            @click="$emit('createEditSurveyForm', fs.id)"
          >
            <i class="ph ph-pencil" />
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import '@/utils/basicDataTableExtend'

export default {
  name: 'ListSurveyForms',

  props: {
    surveyForms: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      table: null,
      orderRepeated: false,
      dataTable: {
        id: 'dataTableListSurveyForms',
        columnDefs: [
          {
            targets: [4],
            orderable: false,
          },
          {
            targets: [4],
            width: 130,
          },
        ],
      },
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
      })
    },

    verifyIsOrderRepeated() {
      const orders = this.surveyForms.map((fs) => fs.order)

      const repeated = orders.filter(
        (order, index) => orders.indexOf(order) !== index,
      )

      return repeated.length > 0 ? `${repeated.join(', ')}` : ''
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
